import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => redirect({ to: "/home" }),
  component: Index,
});

function Index() {
  return null;
}
